import React from "react";
import Modal from "react-bootstrap/Modal";
import methods from "../../../services/utility";

const DeliveryPanel = ({ show, onHide, selectedItem }) => {
  console.log(selectedItem)
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      backdrop={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="kitchen-modal"
    >
      <Modal.Header closeButton>
        <span className="fw-bold">جزئیات سفارش</span>
      </Modal.Header>
      <Modal.Body>
        <div>
          {/* <table className="table table-striped table-md ">
            <thead className="align-middle">
              <tr>
                <th scope="col vertical-center" width="20px">
                  ردیف
                </th>
                <th scope="col vertical-center">کد کالا</th>
                <th scope="col vertical-center">نام کالا</th>
                <th scope="col vertical-center" width="20px">
                  تعداد
                </th>
              </tr>
            </thead>
            <tbody className="align-middle">
              {selectedItem?.invoiceItems
                .filter((p) => p.invoiceItemType === 1)
                .map((iitem, iindex) => (
                  <tr key={iitem.id}>
                    <td>{iindex + 1}</td>
                    <td>{iitem.productCode}</td>
                    <td>{iitem.productName}</td>
                    <td>{iitem.amount}</td>
                  </tr>
                ))}
            </tbody>
          </table> */}
          <div className="table-responsive text-center mt-3">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
                <div className="flex align-items-center">
                  <span className="ps-2">نام مشتری:</span>
                  <span className="fw-bold">{selectedItem?.merchantName}</span>
                </div>
                <div className="flex align-items-center">
                  <span className="ps-2"> شماره:</span>
                  <span className="fw-bold">{selectedItem?.merchantPhone}</span>
                </div>
                <div className="flex align-items-center gap-1">
                  <span className="ps-2"> شماره سفارش:</span>
                  <span className="fw-bold">{selectedItem?.orderNumber}</span>
                </div>
              </div>
                <table className="table table-bordered table-sm align-middle">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center">ردیف</th>
                      <th scope="col vertical-center">تعداد</th>
                      <th scope="col vertical-center">نام کالا</th>
                      <th scope="col vertical-center">قیمت</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {selectedItem?.invoiceItems?.map((item, index) => (
                      <tr key={item.id}>
                        <td scope="row ">{index + 1}</td>
                        <td>{item.amount}</td>
                        <td>{item.productName}</td>
                        <td>{methods.addNumSeperator(item.finalPrice)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="align-middle">
                    <tr className="fw-bold bg-light">
                      <td colSpan="3" className="text-end">
                        جمع کل:
                      </td>
                      <td>
                        {methods.addNumSeperator(
                          selectedItem?.totalFinalPrice
                        )}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeliveryPanel;
